import styled from 'styled-components';

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  height: calc(calc(var(--vh, 1vh) * 100) - 60px);

  > button {
    margin-top: auto;
  }

  h2 {
    margin: 0 auto;
  }
`;

const MainBlock = styled.div`
  overflow: auto;

  h2 {
    padding: 8px;
    margin: 0 0 16px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.greyLight};
    text-align: center;
  }
`;

const InputWrapper = styled.tr<{ withBorder?: boolean }>`
  display: ${({ withBorder }) => withBorder ? 'auto' : 'flex'};

  button {
    width: 100%;
  }

  > *:not(td) {
    width: 100%;
    margin-bottom: 8px;
  }

  > :first-child:not(td) {
    border: 1px solid black;
    line-height: 30px;

    margin-right: 8px;
    padding-left: 8px;
  }

  td {

    text-align: center;
  }

  input {
    top: unset !important;
  }
`;

const VehicleWrapper = styled.div`
  display: flex;
  width: 100%;

  > * {
    width: 100%;
    margin-bottom: 8px;
    border: 1px solid black;
    line-height: 30px;

    margin-right: 8px;
    padding-left: 8px;
  }
`;

const DetailsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 16px;

  thead {
    background: #e9e9e9;
  }
  td,
  th {
    border: 1px solid #5f5d5b;
    padding: 16px;
    text-align: center;
  }
`;

const MainInfoTable = styled.table`
  td {
    border: 1px solid #5f5d5b;
  }
`;

export const Styled = {
  PageWrapper,
  MainBlock,
  InputWrapper,
  VehicleWrapper,
  DetailsTable,
  MainInfoTable,
};
